<template>
  <section class="product-page">
    <product :get-product="product" />
  </section>
</template>

<script>
import Product from '~/marketplace-front-core/components/products/Product'

export default {
  name: 'ProductPageChild',
  components: {
    Product
  },
  middleware: 'productScroll',
  props: {
    product: {
      type: Object,
      default: null
    }
  }
}
</script>
